import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import checkImg from '../../assets/img/check.svg';
import errorImg from '../../assets/img/erroricon.png';
import "../../Component/CommonPopup/commonPopup.css";
// import wsBaseURL from '../../Services/Constant';
// import { w3cwebsocket as W3CWebSocket } from "websocket";


// const ws=new WebSocket(wsBaseURL);
// const contentDefaultMessage = "Start writing your document here";

import PageNotFound from '../FallBackUI/PageNotFound';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const ProxyAccept = (props) => {
  console.log("checking the props value", props)
  const history = useHistory();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  // const { id } = useParams();
  const sellerData = useSelector(state => state.LoginReducer.payload);

  const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMsg, setPopupMsg] = useState("");
  const [popupType, setPopupType] = useState("");
  const [popupActionType, setPopupActionType] = useState("");
  const [popupActionValue, setPopupActionValue] = useState("");
  const [popupActionPath, setPopupActionPath] = useState("");
  // const [userNameError,setUsernameError] = useState("");
  const [alertmessage, setAlertMessage] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [alertimg, setAlertImg] = useState("");
  const email = sellerData.email;

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const [toggleAcceptPopupOpen, setToggleAcceptPopupOpen] = useState(true);
  const toggleCommonPopup = () => {
    setIsCommonPopupOpen(!isCommonPopupOpen);
  }



  const handleAccepts = async () => {



    let request = {
      seller_dealer_id: sellerData.seller_dealer_id,
      seller_id: sellerData.seller_id,
      active: 1,
      car_id: props.carId,
      // email:userName,
      // email:sellerData.email,
      //  password:password,
      buyer_dealer_id: props.proxyDealer,
      buyer_id: props.proxyBuyer,
      updatedBy: sellerData.seller_id,
      createdBy: sellerData.seller_id,
      status: "sold",
      price: props.proxyBid,
      buying_proccess: "seller",
      seller_token: sellerData.seller_token,
      transportation_charge: props.proxyTransport,
      type: "proxy Bid"
    }
    console.log("Save Search Request : ", request);
    // return
    await API.post("carbuy/update", request).then(response => {

      console.log("saveeeeee", response)
      if (response.data.success) {
        setToggleAcceptPopupOpen(false);
        setAlertImg(checkImg);
        setAlertTitle("Successfully Accepted")
        setAlertMessage("Thank you so much for your business, We thank you to let us earn your business.")

      } else {
        const { data } = response;
        setToggleAcceptPopupOpen(false);
        setAlertImg(errorImg);
        setAlertMessage(data.error.err)
      }

    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
      }
    });
  }

  const handleClose = () => {
    props.toggle()
    redirectSoldpage(props.carId, sellerData.seller_dealer_id)
    // props.handleCounterRedirect()
  }
  const redirectSoldpage = (pathid, seller_dealer_id) => {
    history.push({
      pathname: "/soldcardetails",
      state: { backURL: "/carlist", id: pathid, sellerDealerId: seller_dealer_id }
    });
  };
  return (

    <div>


      {errorFlag === true ? <PageNotFound error={errors} /> :
        <>
          {toggleAcceptPopupOpen ?
            (

              <Modal show={true} onHide={props.toggle} centered >
                <Modal.Header className='Terms-login'>
                  <h2 > Proxy Bid Accept confirmation </h2>
                </Modal.Header>
                <Modal.Body>


                  <div class="col-md-12 text-center mb-3">
                    Are you sure wants to accept please confirm
                  </div>
                  {/* <div class=" col-md-12">
                              <input className="textbox " type="text" placeholder="email" defaultValue={email} disabled/>
                              </div> */}
                  {/* <p className="form-input-error">{userNameError}</p> */}
                  {/*  
                              <div class=" col-md-12">
                              <input className="textbox " type="text" placeholder="Password" onChange={(e)=>setPassword(e.target.value)} />
                              </div>
								                	<p className="form-input-error">{passwordError}</p> */}

                  <div class="inactivebtns">
                    <button className="cta-btns" onClick={props.toggle}>Cancel</button>    <button className="cta-btns" onClick={handleAccepts}>Accept</button>
                  </div>
                </Modal.Body>
              </Modal>
            ) :
            (

              <Modal show={true} onHide={props.toggle} centered >
                <Modal.Header className='Terms-login'>
                  <h2 >{alerttitle}</h2>
                </Modal.Header>
                <Modal.Body>
                  <div className="Commonfull-icon">
                    <img alt="" className={alertimg === checkImg ? "successImg " : "errorImg"} src={alertimg}></img>
                  </div>
                  <div class="">
                    <p class="text-center">{alertmessage}</p>
                  </div>
                </Modal.Body>
                <div class="inactivebtns">
                  <button className="cta-btns" onClick={handleClose}>ok</button>
                </div>
              </Modal>

            )
          }

        </>}

      {isCommonPopupOpen && <CommonPopup
        handleClose={isCommonPopupOpen}
        popupTitle={popupTitle}
        popupMsg={popupMsg}
        popupType={popupType}
        popupActionType={popupActionType}
        popupActionValue={popupActionValue}
        popupActionPath={popupActionPath}
      />}
    </div>
  )
}

export default ProxyAccept;